<micro-lookup domain="auth" obj="usersByEmail" [key]="userId"></micro-lookup>
